import {ActionReducerMapBuilder, createSlice} from '@reduxjs/toolkit'

import {TransactionHistoryState, getInitialState} from '@web/slices/transactionHistory/slice'

interface Options {
    extraReducers?: (builder: ActionReducerMapBuilder<TransactionHistoryState>) => void
}

const makeSlice = (options: Options = {}) =>
    createSlice({
        name: 'transactionHistory',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            options.extraReducers?.(builder)
        },
    })

export default makeSlice
